"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESET_STATE = exports.SET = void 0;
var SET = 'user/SET';
exports.SET = SET;
var RESET_STATE = 'user/RESET_STATE';
exports.RESET_STATE = RESET_STATE;